<template>
  <ul class="clt">
    <li v-for="(location_item, index) in children" :key="index">
      <div class="align-top">
        <div class="flex node-select" :class="selected == location_item.uuid ? 'selected-location-item' : ''">
          <div class="flex vertical-center level" @click="select(location_item)" :style="notSelectable(location_item)"
            v-ripple>
            <div>
              <ion-label color="primary" class="smaller">
                <strong>
                  {{ location_item.name }}
                </strong>
              </ion-label>
            </div>

          </div>
        </div>

        <div class="tree-select-button" @click.stop="createLocationItem(location_item)">
          <mdicon class="text-primary" name="plus" />
        </div>

      </div>

      <div class="ml-4">
        <tree-select :level="level + 1" @select="select" @state="state" @create="create"
          :children="sortedItems(location_item.children)" :location_items="location_items"
          :not_selectable_uuids="not_selectable_uuids" :selected="selected">
        </tree-select>
      </div>
    </li>
  </ul>
</template>

<script lang="js">
import {


} from '@ionic/vue';
import uuid from '@/plugins/uuid';
import TreeSelect from './TreeSelect.vue';
import { alertController } from '@ionic/vue';
import {
  add,
  chevronForwardOutline,
  ellipseOutline,
  addCircleOutline,
  removeCircleOutline,
  camera,
  calculator,
  lockClosed,
  lockOpen,
} from 'ionicons/icons';

export default {
  name: 'location-item-tree',
  components: {
    TreeSelect,
  },
  props: ['children', 'level', 'location_items', 'not_selectable_uuids', 'selected'],
  data() {
    return {
      lockClosed,
      lockOpen,
      add,
      chevronForwardOutline,
      ellipseOutline,
      addCircleOutline,
      removeCircleOutline,
      camera,
      calculator,
      counts: []
    }
  },
  created() {
  },
  methods: {
    notSelectable(location_item) {
      if (this.not_selectable_uuids && this.not_selectable_uuids.includes(location_item.uuid)) {
        return "color: #ccc"
      }
    },
    async createLocationItem(location_item) {
      let new_location_item =
      {
        created_by: this.$store.getters.getUser.id,
        parent_uuid: location_item.uuid,
        inspection_id: parseInt(this.$store.getters.getInspectionId),
        location_id: location_item.location_id,
        order_id: location_item.children.length + 1,
        location_item_type_ids: [],
        location_item_types: [],
        uuid: uuid(),
        name: 'Nieuw bouwdeel',
        in_inspection: true,
      }
      const alert = await alertController.create({
        header: 'Nieuw bouwdeel',
        subHeader: 'Bovenliggend bouwdeel: ' + location_item.name,
        inputs: [
          {
            name: 'name',
            type: 'text',
            placeholder: 'Omschrijving'
          },
        ],
        buttons: [
          {
            text: 'Annuleren',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              console.log('Confirm Cancel');
            }
          }, {
            text: 'Opslaan',
            role: 'ok',
            handler: (data) => {
              new_location_item.name = data.name.charAt(0).toUpperCase() + data.name.slice(1)

            }
          }
        ]
      });

      await alert.present();


      // await alert.onWillDismiss()

      // only on confirm alert. Not on cancel

      const { data, role } = await alert.onWillDismiss();

      if (role == 'cancel') {
        return
      }

      let state = {
        opened: true,
        uuid: location_item.uuid
      }
      this.$store.dispatch('setLocationItemState', state)

      let url = '/inspections/' + parseInt(this.$store.getters.getInspectionId) + '/bulk-location-items'
      await this.$requests.post('location_items', url, { location_items: [new_location_item] })

      this.$store.dispatch('setComponentCountKey')

      this.select(new_location_item)
    },

    getState(location_item) {
      let state = this.$store.getters.getLocationItemState(location_item.uuid)

      if (!state) {
        state = {
          opened: false,
          uuid: location_item.uuid
        }

        this.$store.dispatch('setLocationItemState', state)
      }

      return state
    },
    setOpen(location_item) {
      let state = this.$store.getters.getLocationItemState(location_item.uuid)

      state.opened = true
      this.$emit('state', state)
    },
    setOpened(location_item) {
      let state = this.$store.getters.getLocationItemState(location_item.uuid)

      state.opened = !state.opened
      this.$emit('state', state)
    },
    state(location_item) {
      this.$emit('state', location_item)
    },
    isSelected(location_item) {
      let selected_li_uuid = this.$store.getters.getLocationItem;
      if (selected_li_uuid == location_item.uuid) {
        return 'selected'
      }
    },
    create(location_item) {
      this.$emit('create', location_item)
    },
    select(location_item) {

      if (this.not_selectable_uuid && this.not_selectable_uuids.includes(location_item.uuid)) {
        return
      }

      this.$emit('select', location_item)
    },
    sortedItems(items) {
      return items.sort((a, b) => {
        return a.order_id - b.order_id
      });
    },
  },

};
</script>
<style>
.selected-location-item {
  background-color: var(--ion-color-primary-tint) !important;
  border: 2px solid var(--ion-color-primary) !important
}
</style>
